import styled from 'styled-components'
import Dimensions from 'spartacus/styles/dimensions'
import Colors from 'spartacus/styles/colors'

export const Container = styled.div`
  background: ${Colors.UI.Rule};
  padding: 4vh ${Dimensions.nColumns(2)} 8vh;

  @media ${Dimensions.md} {
    padding: 4vh ${Dimensions.nColumns(5)} 8vh;
  }

  @media ${Dimensions.lg} {
    padding: 4vh ${Dimensions.nColumns(7)} 8vh;
  }

  @media ${Dimensions.xl} {
    padding: 4vh ${Dimensions.nColumns(9)} 8vh;
  }
`
